// extracted by mini-css-extract-plugin
export var chatHtmlText = "_p7-2";
export var chatLink = "_p7-0";
export var chatText = "_p7-1";